__webpack_require__.p = "/features-config/onboarding/";